import { Modal } from "../../../../node_modules/@story/story_assets/app/assets/javascripts/modal/modal.js";

window.Modal = Modal;

export { Modal };
